import React, { useEffect, useState } from 'react';
import {
  exportTextScreen,
  ExportToXMLScreenfromExpId,
} from 'components/exports/XMLFileHelper';
import { EFileExportTypes } from 'enums/EFileExportTypes';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { isNullOrUndefined } from 'utils/Global';
import { RMModal, LoadingModal } from 'components/modal';
import { WellNavigationDetails } from 'components/Experiment/constants';

interface IProps {
  exportType: EFileExportTypes;
  setExportType: (e) => void;
  selectedWells: WellNavigationDetails[];
  expData: ExperimentDtoClient;
}
export const FileExportView = ({
  exportType,
  setExportType,
  selectedWells,
  expData,
}: IProps) => {
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState({ show: false, text: '' });
  const [isDirty, setDirty] = useState(expData?.isDirty);

  useEffect(() => {
    switch (exportType) {
      case EFileExportTypes.XMLSCREEN:
        if (expData.isDirty) {
          setError({
            show: true,
            text: 'The selected document has been modified. If you export before saving, the changes will not be included.any changes that have not been saved.\nDo you wish to continue?',
          });
        } else {
          exportToXMlScreen();
        }
        break;
      case EFileExportTypes.Text:
        if (expData.isDirty) {
          setError({
            show: true,
            text: 'The selected document has been modified. If you export before saving, the changes will not be included.any changes that have not been saved.\nDo you wish to continue?',
          });
        } else {
          exportToTextFile();
        }
        break;
    }
  }, [exportType]);

  async function exportToXMlScreen() {
    setLoading(true);
    await ExportToXMLScreenfromExpId(expData.experimentId, expData.expName);
    setExportType(EFileExportTypes.NONE);
    setLoading(false);
  }

  async function exportToTextFile() {
    const wellIds = [];
    selectedWells.forEach((wellDetail) => {
      const plate = expData.plateDto.find((p) => p.plateId === wellDetail.plateID);
      if (!isNullOrUndefined(plate)) {
        const well = plate.ingredients.wellList.find(
          (well) => well.wellNumber === wellDetail.wellNum,
        );
        if (well && well.wellLayerList.length) {
          wellIds.push(well.wellId);
        }
      }
    });
    if (wellIds.length) {
      setLoading(true);
      await exportTextScreen(expData.expName, wellIds);
      setExportType(EFileExportTypes.NONE);
      setLoading(false);
    } else {
      setError({
        show: true,
        text: 'Some of the wells are from empty or unsaved plates. Remove the empty wells from your selection and try again',
      });
    }
  }

  const handleErrorOkay = () => {
    if (isDirty) {
      setError({ show: false, text: isError.text });
      setDirty(false);
      if (EFileExportTypes.Text) {
        exportToTextFile();
      }
      if (EFileExportTypes.XMLSCREEN) {
        exportToXMlScreen();
      }
    } else {
      setError({ show: false, text: isError.text });
      setExportType(EFileExportTypes.NONE);
    }
  };

  return (
    <>
      <RMModal id='fileexportview-error-modal'
        showModal={isError.show}
        setShowModal={(flag) => setError({ show: flag, text: isError.text })}
        onOk={handleErrorOkay}
        heading="Error"
        body={isError.text}
        okButtonText={isDirty ? 'OK' : 'OK, CLOSE'}
        titleClr="#FF2020"
        noButtonText="Cancel"
        onCancel={() => {
          setError({ show: false, text: '' });
          setExportType(EFileExportTypes.NONE);
        }}
        isOkOnly={!isDirty}
      />
      <LoadingModal showModal={isLoading} text="Preparing" />
    </>
  );
};
